import React, { useEffect, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import { useParams } from "react-router-dom";
import { useAssetsApi } from "../../../store/api/hooks/assetsApiHook";
import { useAppLoader } from "../../../_common/pageLoader/appLoaderHook";
import Icon from "../../../components/icons";
import { Controller, useForm } from "react-hook-form";
import FileUpload from "../../../components/elements/form/fileUplaod";
import toast from "react-hot-toast";
import moment from "moment";
import { DATE_FORMAT } from "../../../_common/constant";
import { useDialog } from "../../../store/api/hooks/dialogHook";
import { useWorkRequestApi } from "../../../store/api/hooks/workRequestApiHook";
const Attachments: React.FC = () => {
    const params: any = useParams();
    const assetsAPI = useAssetsApi();
     const workRequestAPI: any = useWorkRequestApi();
    const [columnDefs, setColumnDefs] = useState<any[] | null>(null);
    const [gridApi, setGridApi] = useState<any>(null);
    const { confirm } = useDialog();
    const [gridColumnApi, setGridColumnApi] = useState<any>(null);
    const [attachments, setAttachment] = useState<[]>([]);
    const { showLoader, hideLoader } = useAppLoader();
    const { control, reset, handleSubmit, formState: { errors }, } = useForm<any>();
    const [isRenderFileUpload, setIsRenderFileUpload] = useState<boolean>(true);

    const getAttachmentList = (assetID: any) => {
        const payload = {
            workRequestID: assetID,
        };
        showLoader();
        workRequestAPI.GetWorkRequestAttachments(
            payload,
            (data: any) => {
                hideLoader();
                if(data.files){
                    setAttachment(data.files);
                }else{
                    setAttachment([]);  
                }
               
            },
            (error: any) => {
                hideLoader();
            }
        );
    };

    useEffect(() => {
        if (params.id) {
            getAttachmentList(params.id);
        }
    }, [params]);

    const onGridReady = (params: any) => {
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);
    };

    const onRowClicked = (event: any) => {
        if (!event.event.target.closest('input[type="checkbox"]')) {
            event.node.setSelected(false); // Unselect row if it's clicked, not by checkbox
        }
    };

    const getSelectedRows = () => {
        const selectedNodes = gridApi?.getSelectedNodes();
        const selectedData = selectedNodes.map((node: any) => node.data);
        return selectedData;
    };

    const handleActionChange = (e: any, _params: any) => {
        const action = e.target.value;
        const rowData = _params.data;
        console.log(rowData);

        switch (action) {
            case "delete":
                // Implement delete action
                confirm({
                    type: "delete",
                    title: "Delete Attachment",
                    message: "Are you sure you want to delete this attachment?",
                    onConfirm: () => {
                        console.log("fdsfds",rowData?.workReqeustFileID)
                        workRequestAPI.DeleteWorkRequestFiles(
                            { WorkRequestFileID: rowData?.workReqeustFileID },
                            (data: any) => {
                                //gridApi.applyTransaction({ remove: [rowData] });
                                getAttachmentList(params.id);
                            },
                            (error: any) => {
                                getAttachmentList(params.id);
                                //toast.error(error);
                            });
                        //gridApi.applyTransaction({ remove: [rowData] });
                    },
                });
                break;

            default:
                console.log("Unknown action: ", action);
                break;
        }
        e.target.selectedIndex = -1;
    };

    const attachmentsfile = (data: any) => {
        window.open(data, "_blank");
    };

    const addattachment = (data: any) => {
        const formData = new FormData();
        formData.append("inputFile", data.fileupload);
        formData.append("workRequestID", params.id);
        showLoader();
        workRequestAPI.UploadAttachment(
            formData,
            (resp: any) => {
                toast.success("Attachment Added Successfully");

                resetdata();
                hideLoader();
                getAttachmentList(params.id);
                setIsRenderFileUpload(false);
                setTimeout(() => {
                    setIsRenderFileUpload(true);
                    reset({
                        fileupload: '',
                    });
                })
                

            },
            (error: any) => {
                hideLoader();
                toast.error(error);
            }
        );
    };

    useEffect(() => {
        setColumnDefs([
            {
                headerName: "Attachment File",
                flex: 1,
                field: "attachment-file",
                headerClass: "bg-[#f0f0f0]",
                cellRenderer: (data: any) => {
                    return (
                        <p className="hover:text-primary font-semibold cursor-pointer">
                            {data?.data?.originalFileName
                                ? data?.data?.originalFileName
                                : "-"}
                        </p>
                    );
                },
            },
            {
                headerName: "Uploaded by",
                flex: 1,
                field: "uploaded",
                headerClass: "bg-[#f0f0f0]",
                cellRenderer: (data: any) => {
                    return (
                        <p className="hover:text-primary font-semibold cursor-pointer">
                            {data?.data?.addedByName ? data?.data?.addedByName : "-"}
                        </p>
                    );
                },
            },
            {
                headerName: "Uploaded Date",
                flex: 1,
                field: "date",
                headerClass: "bg-[#f0f0f0]",
                cellRenderer: (data: any) => {
                    return (
                        <p className="hover:text-primary font-semibold cursor-pointer">
                            {data?.data?.addedDate
                                ? moment.utc(data?.data?.addedDate).local().format(DATE_FORMAT)
                                : "-"}
                        </p>
                    );
                },
            },

            {
                headerName: "Download",
                field: "download",
                headerClass: "bg-[#f0f0f0]",
                cellRenderer: (data: any) => {
                    return (
                        <p className="hover:text-primary font-semibold cursor-pointer pt-2">
                            <Icon
                                onClick={() => {
                                    attachmentsfile(data?.data?.fullFilePath);
                                }}
                                name="download"
                            />
                        </p>
                    );
                },
            },
            {
                headerName: "Actions",
                field: "actions",
                headerClass: "bg-[#f0f0f0] text-center",
                width: 90,

                cellRenderer: (params: any) => {
                    return (
                        <div className="relative h-full w-full flex items-center justify-center">
                            <Icon
                                name="threedote"
                                size={1.25}
                                className="text-[#000000]"
                                onClick={(e: any) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    const dropdown: any =
                                        document.querySelector(".action-dropdown");
                                    if (dropdown) {
                                        dropdown.focus();
                                    }
                                    return false;
                                }}
                            />
                            <select
                                onChange={(e) => {
                                    handleActionChange(e, params);
                                    //e.target.value = '';
                                }}
                                onFocus={(e) => {
                                    e.target.selectedIndex = -1;
                                }}
                                className="action-dropdown"
                                value={""}
                                style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    width: "100%",
                                    height: "100%",
                                    opacity: 0,
                                    cursor: "pointer",
                                }}
                            >
                                <option value="delete">Delete</option>
                            </select>
                        </div>
                    );
                },
            },
        ]);
    }, [params]);

    const resetdata = () => {
        reset({
            fileupload: '',
        });
    };

    return (
        <div>
            <div className={ `mt-3` }>
                <div className={ `flex justify-between items-center py-2 mb-0` }>
                    <h4 className={ `py-2 pl-1` } style={{ color: `#000`, fontWeight: `bold`, fontSize: 15 }}>Upload File</h4>
                </div>
                <form className="w-full" onSubmit={handleSubmit(addattachment)}>
                    {isRenderFileUpload && (
                        <Controller
                            name="fileupload"
                            control={control}
                            rules={{ required: "Attachment is required" }}
                            render={({ field: { value, onChange } }) => (
                                <FileUpload
                                    label="Upload Document(PDF, DOC, XLS etc)"
                                    value={value}
                                    isMulti={false}
                                    isFigmaType={true}
                                    accept=".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt"
                                    allowedExt={["pdf", "doc", "docx", "xls", "xlsx", "csv", "txt"]}
                                    retainFiles={true}
                                    className={ `!my-0` }
                                    onChange={(e: any) => {
                                        onChange(e.target.files[0]);
                                    }}
                                    placeholder="Choose Processing Facility"
                                    error={errors?.fileupload?.message as any}
                                />
                            )}
                        />
                    )}

                    <div className="flex justify-end py-5 pb-0 gap-2">
                        <button type="submit" className="bg-success border border-success text-white text-sm px-8 py-2 rounded-md font-medium hover:bg-[#666666] hover:border-[#666666]" style={{ width: 110, height: 40 }}>
                            Add
                        </button>
                        <button type="button" onClick={resetdata} className="bg-secondary border border-secondary text-white text-md px-6 py-2 rounded-md font-medium hover:bg-[#7b5f54] hover:border-[#7b5f54]" style={{ width: 109, height: 40 }}>                    
                            Clear
                        </button>
                    </div>
                </form>                
            </div>
            <div className={ `mt-3` }>
                <div className={ `flex justify-between items-center py-2 mb-0` }>
                    <h4 className={ `py-2 pl-1` } style={{ color: `#000`, fontWeight: `bold`, fontSize: 15 }}>Attachments</h4>
                </div>
                <div>
                    <AgGridReact
                        columnDefs={columnDefs} // Pass columnDefs
                        rowData={attachments || []} // Pass rowData
                        pagination={false}
                        onGridReady={onGridReady}
                        onRowClicked={onRowClicked}
                        domLayout="autoHeight"
                        noRowsOverlayComponent={() => (
                            <div className="flex items-center justify-center h-full">
                                <div className="text-center text-gray-500">
                                    <div className="text-lg font-medium">No Data Found</div>
                                </div>
                            </div>
                        )}
                    />
                </div>
            </div>
        </div>
    );
};

export default Attachments;
